export default __webpack_public_path__ + "static/media/footer.bd7ce55d.png";